import React, { lazy } from "react";

const LazyBusinessRules = lazy(() => import("./BusinessRules"));

const BusinessRules = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyBusinessRules {...props} />;

export default BusinessRules;
